export default "__VITE_ASSET__CmB8CTlE__"